export default __webpack_public_path__ + "static/media/04.677dbb08.jpg";